export default (linkedDefinitions) => ({
    name: "linked_operations",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'linked operations %1 %2 ',
                "args0": [
                    {
                        "type": "field_dropdown",
                        "name": "LINK_DEFINITION",
                        "options": [
                            ...linkedDefinitions.map((obj) => [obj.name, obj.id])
                        ]
                    },
                    {
                        "type": "field_dropdown",
                        "name": "FIELD",
                        "options": [
                            ["ID", "id"],
                            ["Source", "source"],
                            ...Object.keys(linkedDefinitions[0].operationDefinition.model.dynaProperties)
                                .map(key => linkedDefinitions[0].operationDefinition.model.dynaProperties[key])
                                .map(param => {

                                    if (param.details.type === 'DECIMAL') {
                                        return [param.name, "content.getValues().get('" + param.name + "') / " + Math.pow(10, param.details.precision)]
                                    } else {
                                        return [param.name, "content.getValues().get('" + param.name + "')"]
                                    }

                                })
                        ]
                    }
                ],
                "output": null,
                "colour": 4.5,
                "tooltip": "Creates cash event with specified parameters",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        let linkDefinitionId = block.getFieldValue("LINK_DEFINITION");
        let param = block.getFieldValue("FIELD");

        return [`linkedOperations.get('${linkDefinitionId}').${param}`, blocklyInstance.JavaScript.ORDER_NONE];
        ;
    }
})
